import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Tooltip.css';
import { Lados } from '../../utils/EnumsUtils';

const Tooltip = ({ text, children, lado = Lados.NENHUM }) => {
  const [visible, setVisible] = useState(false);
  const [showPortal, setShowPortal] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const ref = useRef(null);

  const show = () => {
    setShowPortal(true);
    const rect = ref.current.getBoundingClientRect();
    let top = rect.top + window.scrollY;
    let left = rect.left + window.scrollX + rect.width / 2;
    let transform = 'translate(-50%, -100%)';
    if (lado === Lados.ESQUERDA) {
      left = rect.left + window.scrollX;
      transform = 'translate(-100%, -100%)';
    } else if (lado === Lados.DIREITA) {
      left = rect.left + window.scrollX + rect.width;
      transform = 'translate(0, -100%)';
    }
    setCoords({ top, left, transform });
    setVisible(true);
  };
  const hide = () => {
    setVisible(false);
    setTimeout(() => setShowPortal(false), 200);
  };

  return (
    <>
      <div
        ref={ref}
        className="tooltip-container"
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        {children}
      </div>
      {showPortal && text && text.trim() !== '' &&
        createPortal(
          <div
            className={`tooltip-portal${visible ? ' visible' : ''}`}
            style={{ top: coords.top, left: coords.left, transform: coords.transform }}
          >{text}</div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;
